var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 48,
    viewBox: "0 0 35 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.76353 25.1545H5.39163C6.49555 25.1545 7.68424 25.6981 7.63506 27.0639C7.59195 28.2915 6.84976 29.0305 5.39163 29.0305H2.76353V25.1545ZM0 22.8689V36.0694H2.76353V31.277H5.82645C8.31074 31.277 10.0598 29.52 10.0598 27.1415C10.0598 24.6577 8.17903 22.8693 5.82645 22.8693L0 22.8689Z",
    fill: "#202F46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7687 25.1545H16.8125C19.4917 25.1545 20.4864 26.8957 20.4948 29.3289C20.4977 31.809 19.39 33.8228 17.0547 33.8228H14.7686L14.7687 25.1545ZM12.082 22.8689V36.0694H17.61C21.3964 36.0694 23.3751 32.7389 23.3161 29.3293C23.2505 25.616 20.7039 22.8684 17.1944 22.8684L12.082 22.8689Z",
    fill: "#202F46"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5959 22.8694V36.0699H28.3604V30.5044H34.1645V28.1757H28.3604V25.1746H35.0003V22.8697L25.5959 22.8694Z",
    fill: "#202F46"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3432 0.000359652L0.00732422 11.9026V20.9444H2.54127V13.648H14.0396V5.14286H11.5005V11.1099H4.05324L11.5005 2.53814H32.4533V20.9445H34.9915V0L10.3432 0.000359652Z",
    fill: "#202F46"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.00732422 38.0094V47.2685L34.9919 47.3027V33.5312H32.4538V44.7621L2.54067 44.7344V38.0098L0.00732422 38.0094Z",
    fill: "#202F46"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.0a6e8b977c99fe16d55688e5452939b9.svg";
export { ForwardRef as ReactComponent };